/**
 * Slider — suwak z wyświetlaniem wartości (F12.B T12.B.2).
 * Adaptacja z SellCall.
 */

interface SliderProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  showValue?: boolean;
}

export function Slider({
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  showValue = true,
}: SliderProps) {
  const percentage = max > min ? ((value - min) / (max - min)) * 100 : 0;

  return (
    <div className="space-y-1">
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value ?? min}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-full h-2 cursor-pointer appearance-none rounded-full"
        style={{
          background: `linear-gradient(to right, var(--color-accent-500, #6366f1) 0%, var(--color-accent-500, #6366f1) ${percentage}%, var(--color-border-primary, #e5e7eb) ${percentage}%, var(--color-border-primary, #e5e7eb) 100%)`,
        }}
      />
      {showValue && (
        <div className="flex items-center justify-between">
          <span className="text-xs text-text-muted">{min}</span>
          <span className="rounded-full bg-accent-100 px-2 py-0.5 text-xs font-semibold text-accent-700">
            {value}
          </span>
          <span className="text-xs text-text-muted">{max}</span>
        </div>
      )}
    </div>
  );
}
